import { API_BASE_URL } from "../config";
import React, { useState, useEffect } from "react";
import axios from "axios";

const Tickets = () => {
  const [tickets, setTickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subject, setSubject] = useState("");
  const [category, setCategory] = useState("General");
  const [message, setMessage] = useState("");
  const [replyMessage, setReplyMessage] = useState("");
  const [selectedTicket, setSelectedTicket] = useState(null);
  const [isNewTicketOpen, setIsNewTicketOpen] = useState(false);

  const fetchTickets = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${API_BASE_URL}/api/client/tickets`);
      setTickets(Array.isArray(res.data) ? res.data : (res.data?.Tickets?.toLowerCase() || res.data?.data || res.data?.items || res.data?.users || res.data?.trades || res.data?.holdings || res.data?.positions || res.data?.orders || res.data?.logs || res.data?.withdrawals || []));
    } catch (err) {
      console.error("Error fetching tickets", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTickets();
  }, []);

  const handleCreateTicket = async (e) => {
    e.preventDefault();
    try {
      await axios.post(`${API_BASE_URL}/api/client/tickets`, {
        subject,
        category,
        message,
      });
      setSubject("");
      setMessage("");
      setIsNewTicketOpen(false);
      fetchTickets();
    } catch (err) {
      alert("Failed to create ticket");
    }
  };

  const handleSendReply = async (e) => {
    e.preventDefault();
    if (!replyMessage || !selectedTicket) return;
    try {
      const res = await axios.post(`${API_BASE_URL}/api/client/tickets/${selectedTicket._id}/reply`, {
        message: replyMessage,
      });
      setSelectedTicket(res.data.ticket);
      setReplyMessage("");
      fetchTickets();
    } catch (err) {
      alert("Failed to send reply");
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "20px" }}>
        <div>
          <h2 style={{ margin: 0, color: "#333" }}>Help & Support Center</h2>
          <p style={{ margin: "4px 0 0", color: "#666", fontSize: "14px" }}>Communicate with platform admin & support team</p>
        </div>
        <button onClick={() => setIsNewTicketOpen(true)} style={{ backgroundColor: "#387ed1", color: "#fff", border: "none", padding: "10px 18px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }}>
          + New Support Inquiry
        </button>
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1.5fr", gap: "20px" }}>
        {/* Ticket List */}
        <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          <h3 style={{ marginTop: 0, fontSize: "16px", color: "#444" }}>Your Inquiries</h3>
          {loading ? (
            <p>Loading tickets...</p>
          ) : tickets.length === 0 ? (
            <p style={{ color: "#888", fontSize: "14px" }}>No support tickets found.</p>
          ) : (
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
              {tickets.map((t) => (
                <div
                  key={t._id}
                  onClick={() => setSelectedTicket(t)}
                  style={{
                    padding: "12px",
                    borderRadius: "6px",
                    border: selectedTicket?._id === t._id ? "2px solid #387ed1" : "1px solid #eee",
                    backgroundColor: selectedTicket?._id === t._id ? "#f4f8fd" : "#fff",
                    cursor: "pointer",
                  }}
                >
                  <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                    <span style={{ fontWeight: "bold", fontSize: "14px", color: "#333" }}>{t.subject}</span>
                    <span
                      style={{
                        padding: "2px 8px",
                        borderRadius: "10px",
                        fontSize: "11px",
                        fontWeight: "bold",
                        backgroundColor: t.status === "open" ? "#fff8e1" : t.status === "in_progress" ? "#e8f5e9" : "#eceff1",
                        color: t.status === "open" ? "#f57f17" : t.status === "in_progress" ? "#2e7d32" : "#546e7a",
                      }}
                    >
                      {t.status.toUpperCase()}
                    </span>
                  </div>
                  <div style={{ fontSize: "12px", color: "#666", marginTop: "4px" }}>
                    Category: {t.category} • {new Date(t.createdAt).toLocaleDateString()}
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Ticket Details & Chat */}
        <div style={{ backgroundColor: "#fff", borderRadius: "8px", padding: "16px", boxShadow: "0 2px 8px rgba(0,0,0,0.06)" }}>
          {selectedTicket ? (
            <div>
              <h3 style={{ marginTop: 0, color: "#387ed1" }}>{selectedTicket.subject}</h3>
              <div style={{ fontSize: "13px", color: "#666", marginBottom: "16px" }}>
                Status: <strong>{selectedTicket.status.toUpperCase()}</strong> | Category: {selectedTicket.category}
              </div>

              <div style={{ backgroundColor: "#f9f9f9", padding: "12px", borderRadius: "6px", marginBottom: "16px", fontSize: "14px" }}>
                <strong>You:</strong> {selectedTicket.message}
              </div>

              <h4 style={{ fontSize: "14px", color: "#555" }}>Thread History ({selectedTicket.replies?.length || 0})</h4>
              <div style={{ display: "flex", flexDirection: "column", gap: "10px", maxHeight: "250px", overflowY: "auto", marginBottom: "16px" }}>
                {(selectedTicket.replies || []).map((r, idx) => (
                  <div
                    key={idx}
                    style={{
                      padding: "10px 14px",
                      borderRadius: "8px",
                      maxWidth: "85%",
                      alignSelf: r.senderRole === "admin" ? "flex-start" : "flex-end",
                      backgroundColor: r.senderRole === "admin" ? "#eef6ff" : "#e8f5e9",
                      border: r.senderRole === "admin" ? "1px solid #bbdefb" : "1px solid #c8e6c9",
                    }}
                  >
                    <div style={{ fontSize: "11px", fontWeight: "bold", color: r.senderRole === "admin" ? "#1976d2" : "#2e7d32", marginBottom: "2px" }}>
                      {r.senderName} ({r.senderRole.toUpperCase()})
                    </div>
                    <div style={{ fontSize: "13px" }}>{r.message}</div>
                    <div style={{ fontSize: "10px", color: "#888", textAlign: "right", marginTop: "4px" }}>
                      {new Date(r.createdAt).toLocaleTimeString()}
                    </div>
                  </div>
                ))}
              </div>

              <form onSubmit={handleSendReply} style={{ display: "flex", gap: "10px" }}>
                <input
                  type="text"
                  value={replyMessage}
                  onChange={(e) => setReplyMessage(e.target.value)}
                  placeholder="Type your reply..."
                  required
                  style={{ flex: 1, padding: "10px", borderRadius: "6px", border: "1px solid #ccc" }}
                />
                <button type="submit" style={{ backgroundColor: "#387ed1", color: "#fff", border: "none", padding: "10px 16px", borderRadius: "6px", cursor: "pointer", fontWeight: "bold" }}>
                  Send
                </button>
              </form>
            </div>
          ) : (
            <div style={{ padding: "40px", textAlign: "center", color: "#888" }}>
              Select a ticket on the left to view the conversation thread.
            </div>
          )}
        </div>
      </div>

      {/* New Ticket Modal */}
      {isNewTicketOpen && (
        <div style={overlayStyle}>
          <div style={modalStyle}>
            <h3 style={{ marginTop: 0, color: "#387ed1" }}>New Support Inquiry</h3>
            <form onSubmit={handleCreateTicket}>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Category</label>
                <select value={category} onChange={(e) => setCategory(e.target.value)} style={inputStyle}>
                  <option value="General">General Inquiry</option>
                  <option value="Wallet">Funds & Withdrawal</option>
                  <option value="KYC">KYC Verification</option>
                  <option value="Trading">Orders & Trades</option>
                </select>
              </div>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Subject</label>
                <input
                  type="text"
                  value={subject}
                  onChange={(e) => setSubject(e.target.value)}
                  placeholder="Summary of issue"
                  required
                  style={inputStyle}
                />
              </div>
              <div style={{ marginBottom: "14px" }}>
                <label style={labelStyle}>Message</label>
                <textarea
                  rows={4}
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Describe your inquiry in detail..."
                  required
                  style={{ ...inputStyle, fontFamily: "inherit" }}
                />
              </div>
              <div style={{ display: "flex", justifyContent: "flex-end", gap: "10px" }}>
                <button type="button" onClick={() => setIsNewTicketOpen(false)} style={btnGreyStyle}>Cancel</button>
                <button type="submit" style={btnPrimaryStyle}>Submit Ticket</button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
};

const overlayStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  backgroundColor: "rgba(0,0,0,0.5)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 2000,
};

const modalStyle = {
  backgroundColor: "#fff",
  padding: "24px",
  borderRadius: "10px",
  width: "100%",
  maxWidth: "460px",
  boxShadow: "0 8px 32px rgba(0,0,0,0.2)",
};

const labelStyle = {
  display: "block",
  fontSize: "13px",
  fontWeight: 500,
  marginBottom: "6px",
  color: "#444",
};

const inputStyle = {
  width: "100%",
  padding: "10px",
  borderRadius: "6px",
  border: "1px solid #ccc",
  fontSize: "14px",
  boxSizing: "border-box",
};

const btnGreyStyle = {
  padding: "10px 16px",
  backgroundColor: "#eee",
  color: "#333",
  border: "none",
  borderRadius: "6px",
  cursor: "pointer",
};

const btnPrimaryStyle = {
  padding: "10px 18px",
  backgroundColor: "#387ed1",
  color: "#fff",
  border: "none",
  borderRadius: "6px",
  fontWeight: "bold",
  cursor: "pointer",
};

export default Tickets;
